import { createContext, useContext, useState } from "react";

export type DurationFilterType = 1 | 3 | 7 | 30;

export type DurationFilterContextType = {
  duration: DurationFilterType;
  getFromDate: () => Date;
  getToDate: () => Date;
  setDuration: (duration: DurationFilterType) => void;
};

const DurationFilterContext = createContext<DurationFilterContextType>({
  duration: 7,
  getFromDate: () => new Date(),
  getToDate: () => new Date(),
  setDuration: () => {},
});

export function DurationFilterProvider({ children }: { children: React.ReactNode }) {
  const [duration, setDuration] = useState<DurationFilterType>(7);

  const getToDate = () => {
    return new Date();
  };

  const getFromDate = () => {
    return new Date(Date.now() - duration * 24 * 60 * 60 * 1000)
  };

  return (
    <DurationFilterContext.Provider value={{ duration, setDuration, getFromDate, getToDate }}>
      {children}
    </DurationFilterContext.Provider>
  );
}

export function useDurationFilter() {
  return useContext(DurationFilterContext);
}
